import { useEffect, useState } from 'react';
import { getInstructionalLevels } from '../../services/instructionalLevel/listInstructionalLevelService.js';

export const useInstructionalLevelsList = () => {
    const [instructionalLevels, setInstructionalLevels] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;
    const [error, setError] = useState('');
    // ordenamiento
    const [sortField, setSortField] = useState('');
    const [sortOrder, setSortOrder] = useState('asc');
    
    useEffect(() => {
        loadInstructionalLevels();
    }, []);

    const loadInstructionalLevels = async () => {
        const data = await getInstructionalLevels();
        data.sort((a, b) => a.name.localeCompare(b.name));
        setInstructionalLevels(data);
    };

    const handleSort = (field) => {
        const order = sortField === field && sortOrder === 'asc' ? 'desc' : 'asc';

        setSortField(field);
        setSortOrder(order);

        setInstructionalLevels(prev =>
            [...prev].sort((a, b) => {
                const aValue = field.split('.').reduce((o, i) => o?.[i], a);
                const bValue = field.split('.').reduce((o, i) => o?.[i], b);

                if (aValue < bValue) return order === 'asc' ? -1 : 1;
                if (aValue > bValue) return order === 'asc' ? 1 : -1;
                return 0;
            })
        );
    };

    return {
        instructionalLevels,
        searchTerm,
        setSearchTerm,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        error,
        setError,
        sortField,
        sortOrder,
        setSortField,
        setSortOrder,
        handleSort
    };
}